import React, { useEffect, useState } from "react";
import 'bootstrap/dist/css/bootstrap.min.css';

const departments = [
    {
        name: "प्रशासन शाखा",
        content: (
            <div className="card mb-4 shadow-sm">
                <div className="card-body">
                    <div className="card mb-4 shadow-sm">
                        <div className="card-body">
                            <h5 className="card-title text-center text-primary mb-3">कार्य</h5>
                            <div className="text-justify">
                                <ol className="list-group list-group-flush">
                                    <li className="list-group-item border-0 px-0">विश्वविद्यालय के स्थापना शाखा सम्बन्धी सभी मामले ।</li>
                                    <li className="list-group-item border-0 px-0">विश्वविद्यालय के शिक्षण एवं गैर-शिक्षण कर्मचारियों की नियमित एवं संविदा आधार पर भर्ती ।</li>
                                    <li className="list-group-item border-0 px-0">नियमित कर्मचारियों के सेवा सम्बन्धी मामले ।</li>
                                    <li className="list-group-item border-0 px-0">नियमित कर्मचारियों के सभी सेवा अभिलेख रखना ।</li>
                                    <li className="list-group-item border-0 px-0">यह कार्यालय विश्वविद्यालय अधिनियम एवं संविधि, विश्वविद्यालय कैलेण्डर, कार्यकारी परिषद के निर्णयों और अन्य लागू नियमों के प्रावधानों के अनुसार माननीय कुलपति और योग्य कुलसचिव के नियंत्रण और निर्देशन में अपने कर्तव्यों और कार्यों का निर्वहन करता है ।</li>
                                    <li className="list-group-item border-0 px-0">HKRN कर्मचारियों से सम्बन्धित सभी कार्य ।</li>
                                </ol>
                            </div>
                        </div>
                    </div>

                    <div className="card mb-4 shadow-sm">
                        <div className="card-body">
                            <h5 className="card-title text-center text-primary mb-4">प्रशासन शाखा में कार्यरत अधिकारी एवं सदस्य</h5>
                            <div className="table-responsive">
                                <table className="table table-bordered table-hover align-middle">
                                    <thead className="table-primary text-center">
                                        <tr>
                                            <th scope="col">क्र. सं.</th>
                                            <th scope="col">सदस्य का नाम</th>
                                            <th scope="col">पद</th>
                                            <th scope="col">आधिकारिक ई-मेल</th>
                                        </tr>
                                    </thead>
                                    <tbody className="text-center">
                                        <tr>
                                            <td>1</td>
                                            <td>श्री सुभाष चन्द</td>
                                            <td>अधीक्षक</td>
                                            <td><a href="mailto:supdtadmin@mvsu.ac.in" className="text-decoration-none">supdtadmin@mvsu.ac.in</a></td>
                                        </tr>
                                        <tr>
                                            <td>2</td>
                                            <td>श्री इन्द्रजीत</td>
                                            <td>सहायक (प्रतिनियुक्ति)</td>
                                            <td><a href="mailto:inderjeetgju@gmail.com" className="text-decoration-none">inderjeetgju@gmail.com</a></td>
                                        </tr>
                                        <tr>
                                            <td>3</td>
                                            <td>श्रीमती स्वीटी</td>
                                            <td>लिपिक (HKRN)</td>
                                            <td><a href="mailto:sweetysardana1981@gmail.com" className="text-decoration-none">sweetysardana1981@gmail.com</a></td>
                                        </tr>
                                        <tr>
                                            <td>4</td>
                                            <td>श्री अजय कुमार</td>
                                            <td>लिपिक (HKRN)</td>
                                            <td><a href="mailto:ajay.keorak143@gmail.com" className="text-decoration-none">ajay.keorak143@gmail.com</a></td>
                                        </tr>
                                        <tr>
                                            <td>5</td>
                                            <td>श्री संजीव कुमार</td>
                                            <td>डी.ई.ओ. (HKRN)</td>
                                            <td><a href="mailto:keoraksanju@gmail.com" className="text-decoration-none">keoraksanju@gmail.com</a></td>
                                        </tr>
                                        <tr>
                                            <td>6</td>
                                            <td>श्री अंकुर</td>
                                            <td>डी.ई.ओ. (HKRN)</td>
                                            <td><a href="mailto:asbairagiofficial@gmail.com" className="text-decoration-none">asbairagiofficial@gmail.com</a></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        ),
    },
    {
        name: "शैक्षणिक शाखा",
        content: (
            <div className="card mb-4 shadow-sm">
                <div className="card-body">
                    <div className="card mb-4 shadow-sm">
                        <div className="card-body">
                            <h5 className="card-title text-center text-primary mb-3">कार्य एवं उद्देश्य</h5>
                            <p className="text-justify">
                                विश्वविद्यालय अधिनियम, विश्वविद्यालय कैलेंडर एवं विनियमों के अंतर्गत विभिन्न प्रकार के शैक्षणिक कार्यों का संचालन करती है, जो निम्नलिखित हैं:
                            </p>
                        </div>
                    </div>

                    <div className="card mb-4 shadow-sm">
                        <div className="card-body">
                            <h5 className="card-title text-center text-primary mb-3">प्रमुख कार्य</h5>
                            <div className="text-justify">
                                <ul className="list-group list-group-flush">
                                    <li className="list-group-item border-0 px-0">संबंधित शिक्षण विभागों<strong>(UTDs)</strong> के सहयोग से <strong>UGC, AICTE, HEC, AIU, HSCS, NCTE, DTE</strong> आदि वैधानिक संस्थाओं से मौजूदा एवं नवीन पाठ्यक्रमों की स्वीकृति/मान्यता हेतु पत्राचार करना ।</li>
                                    <li className="list-group-item border-0 px-0">विश्वविद्यालय की विभिन्न निकायों जैसे संकाय, कार्यकारी परिषद, शैक्षणिक परिषद, विश्वविद्यालय सभा, वित्त समिति, शैक्षणिक योजना बोर्ड, <strong>DRC, PGBOS&R, UGBOS</strong> एवं खेल परिषद आदि की संरचना का अनुरक्षण करना ।</li>
                                    <li className="list-group-item border-0 px-0">शैक्षणिक परिषद, कार्यकारी परिषद, विश्वविद्यालय सभा एवं शैक्षणिक योजना बोर्ड आदि की बैठकें आयोजित करना, उनका एजेंडा तैयार करना तथा निर्णयों के अनुपालन हेतु कार्यवाही करना ।</li>
                                    <li className="list-group-item border-0 px-0">विश्वविद्यालय अधिनियम, विनियम एवं विश्वविद्यालय कैलेंडर का अनुरक्षण करना ।</li>
                                    <li className="list-group-item border-0 px-0">विश्वविद्यालय की वार्षिक रिपोर्ट एवं सूचना पुस्तिका <strong>(Handbook of Information)</strong> का अनुरक्षण करना ।</li>
                                    <li className="list-group-item border-0 px-0">सभी प्रकार के पाठ्यक्रमों का अनुरक्षण एवं प्रसार करना ।</li>
                                    <li className="list-group-item border-0 px-0">सभी प्रकार की शोध परियोजनाएँ/प्रस्ताव संबंधित संस्थानों को भेजना ।</li>
                                    <li className="list-group-item border-0 px-0">विभिन्न शैक्षणिक समितियों की अधिसूचना जारी करना ।</li>
                                    <li className="list-group-item border-0 px-0">नियमित पाठ्यक्रमों की शुल्क संरचना का प्रारूप तैयार करना ।</li>
                                    <li className="list-group-item border-0 px-0">आवश्यकता अनुसार शैक्षणिक विषयों पर सभी संकायाध्यक्षों की बैठकें आयोजित करना ।</li>
                                    <li className="list-group-item border-0 px-0">शैक्षणिक विषयों से संबंधित अन्य विश्वविद्यालयों से पत्राचार करना ।</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="card mb-4 shadow-sm">
                        <div className="card-body">
                            <h5 className="card-title text-center text-primary mb-4">शैक्षणिक शाखा में कार्यरत अधिकारी एवं सदस्य</h5>
                            <div className="table-responsive">
                                <table className="table table-bordered table-hover align-middle">
                                    <thead className="table-primary text-center">
                                        <tr>
                                            <th scope="col">क्रं. सं.</th>
                                            <th scope="col">सदस्य का नाम</th>
                                            <th scope="col">पद</th>
                                            <th scope="col">अधिकारिक ई-मेल</th>
                                        </tr>
                                    </thead>
                                    <tbody className="text-center">
                                        <tr>
                                            <td>1</td>
                                            <td>श्री अंकुर गुप्ता</td>
                                            <td>अधीक्षक, शैक्षणिक शाखा</td>
                                            <td><a href="mailto:academic@mvsu.ac.in" className="text-decoration-none">academic@mvsu.ac.in</a></td>
                                        </tr>
                                        <tr>
                                            <td>2</td>
                                            <td>श्री प्रवीन कुमार</td>
                                            <td>सहायक, शैक्षणिक शाखा</td>
                                            <td><a href="mailto:academic@mvsu.ac.in" className="text-decoration-none">academic@mvsu.ac.in</a></td>
                                        </tr>
                                        <tr>
                                            <td>3</td>
                                            <td>डॉ. महावीर</td>
                                            <td>लिपिक, शैक्षणिक शाखा</td>
                                            <td><a href="mailto:academic@mvsu.ac.in" className="text-decoration-none">academic@mvsu.ac.in</a></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        ),
    },
    {
        name: "वित्त एवं लेखा शाखा",
        content: (
            <div className="card mb-4 shadow-sm">
                <div className="card-body">
                    <div className="card mb-4 shadow-sm">
                        <div className="card-body">
                            <h5 className="card-title text-center text-primary mb-3">कार्य एवं उद्देश्य</h5>
                            <p className="text-justify text-muted">
                                वित्त एवं लेखा शाखा से संबंधित जानकारी यहां उपलब्ध होगी।
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        ),
    },
    {
        name: "छात्रवृत्ति शाखा",
        content: (
            <div className="card mb-4 shadow-sm">
                <div className="card-body">
                    <div className="card mb-4 shadow-sm">
                        <div className="card-body">
                            <h5 className="card-title text-center text-primary mb-3">कार्य एवं उद्देश्य</h5>
                            <p className="text-justify">
                                विश्वविद्यालय के विद्यार्थियों को विभिन्न प्रकार की छात्रवृत्तियाँ प्रदान करने, उनके आवेदन की प्रक्रिया को सुचारु रूप से संचालित करने एवं शासन/यूजीसी/अन्य एजेंसियों से संबंधित छात्रवृत्ति योजनाओं के कार्यान्वयन हेतु उत्तरदायी शाखा । विश्वविद्यालय आरक्षित वर्गों के छात्रों के कल्याण हेतु प्रवेश, छात्रवृत्तियों आदि से संबंधित विश्वविद्यालय अनुदान आयोग (UGC)/भारत सरकार/राज्य सरकार की विभिन्न योजनाओं के उचित कार्यान्वयन को सुनिश्चित करता है ।
                            </p>
                        </div>
                    </div>

                    <div className="card mb-4 shadow-sm">
                        <div className="card-body">
                            <h5 className="card-title text-center text-primary mb-3">छात्रवृत्तियों की सूची</h5>
                            <div className="text-justify">
                                <ol className="list-group list-group-flush">
                                    <li className="list-group-item border-0 px-0">पोस्ट मैट्रिक छात्रवृत्ति</li>
                                    <li className="list-group-item border-0 px-0">अनुसूचित जाति व अनुसूचित जनजाति छात्रवृत्ति</li>
                                    <li className="list-group-item border-0 px-0">शंकरीलाल भागीरथी छात्रवृत्ति</li>
                                    <li className="list-group-item border-0 px-0">मेधावी छात्रवृत्ति (महर्षि वाल्मीकि संस्कृत विश्वविद्यालय, कैथल)</li>
                                    <li className="list-group-item border-0 px-0">शोध छात्रवृत्ति (शोधार्थियों के लिए)</li>
                                    <li className="list-group-item border-0 px-0">हरियाणा संस्कृति अकादमी, पंचकुला</li>
                                    <li className="list-group-item border-0 px-0">केन्द्रीय संस्कृत विश्वविद्यालय द्वारा संस्कृत अध्ययन करने वाले छात्रों को दी जाने वाली छात्रवृत्ति</li>
                                </ol>
                            </div>
                        </div>
                    </div>

                    <div className="card mb-4 shadow-sm">
                        <div className="card-body">
                            <h5 className="card-title text-center text-primary mb-4">छात्रवृत्ति शाखा में कार्यरत अधिकारी एवं सदस्य</h5>
                            <div className="table-responsive">
                                <table className="table table-bordered table-hover align-middle">
                                    <thead className="table-primary text-center">
                                        <tr>
                                            <th scope="col">क्रं. सं.</th>
                                            <th scope="col">सदस्य का नाम</th>
                                            <th scope="col">पद</th>
                                            <th scope="col">अधिकारिक ई-मेल</th>
                                        </tr>
                                    </thead>
                                    <tbody className="text-center">
                                        <tr>
                                            <td>1</td>
                                            <td>श्री अंकुर गुप्ता</td>
                                            <td>अधीक्षक, शैक्षणिक शाखा</td>
                                            <td><a href="mailto:academic@mvsu.ac.in" className="text-decoration-none">academic@mvsu.ac.in</a></td>
                                        </tr>
                                        <tr>
                                            <td>2</td>
                                            <td>श्री प्रवीन कुमार</td>
                                            <td>सहायक, छात्रवृति शाखा</td>
                                            <td><a href="mailto:academic@mvsu.ac.in" className="text-decoration-none">academic@mvsu.ac.in</a></td>
                                        </tr>
                                        <tr>
                                            <td>3</td>
                                            <td>श्री सिकन्दर लाल</td>
                                            <td>डी.ई.ओ., छात्रवृत्ति शाखा</td>
                                            <td><a href="mailto:sch@mvsu.ac.in" className="text-decoration-none">sch@mvsu.ac.in</a></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        ),
    },
    {
        name: "पंजीकरण शाखा",
        content: (
            <div className="card mb-4 shadow-sm">
                <div className="card-body">
                    <div className="card mb-4 shadow-sm">
                        <div className="card-body">
                            <h5 className="card-title text-center text-primary mb-3">विभाग परिचय</h5>
                            <p className="text-justify">
                                वर्तमान में विश्वविद्यालय सभी संकायों में कई कार्यक्रमों की पेशकश कर रहा है। स्नातक/स्नातकोत्तर पाठ्यक्रमों के लगभग 1000 छात्रों ने इस विश्वविद्यालय में सभी प्रयोजनों के लिए एक अद्वितीय पंजीकरण संख्या के साथ नामांकन किया है। विश्वविद्यालय आरक्षित श्रेणियों के छात्रों के कल्याण के लिए प्रवेश, छात्रवृत्ति आदि से संबंधित यूजीसी/भारत सरकार/राज्य सरकार की विभिन्न योजनाओं का उचित कार्यान्वयन सुनिश्चित करता है।
                            </p>
                        </div>
                    </div>

                    <div className="card mb-4 shadow-sm">
                        <div className="card-body">
                            <h5 className="card-title text-center text-primary mb-3">कार्य एवं उद्देश्य</h5>
                            <p className="text-justify">
                                विश्वविद्यालय से संबद्ध महाविद्यालयों एवं संस्थानों में अध्ययनरत छात्रों का पंजीकरण करना, पंजीकरण प्रक्रिया के अंतर्गत छात्रों के विवरण का संकलन, प्रत्येक सत्र के प्रारंभ में नए छात्रों का पंजीकरण सुनिश्चित करना, पंजीकरण प्रमाणपत्र निर्गत करना, छात्रों के नाम, विषय अथवा महाविद्यालय में परिवर्तन हेतु कार्रवाई करना, अन्य विश्वविद्यालयों से स्थानांतरित छात्रों का समायोजन एवं पंजीकरण करना, परीक्षा हेतु पात्रता सुनिश्चित करने के लिए पंजीकरण डेटा का संप्रेषण करना, विश्वविद्यालय के नियमों के अनुसार पंजीकरण संबंधी दिशा-निर्देश जारी करना तथा संबंधित विभागों, महाविद्यालयों एवं छात्रों को पंजीकरण से संबंधित सहयोग एवं पत्राचार प्रदान करना है ।
                            </p>
                        </div>
                    </div>

                    <div className="card mb-4 shadow-sm">
                        <div className="card-body">
                            <h5 className="card-title text-center text-primary mb-4">पंजीकरण शाखा में कार्यरत अधिकारी एवं सदस्य</h5>
                            <div className="table-responsive">
                                <table className="table table-bordered table-hover align-middle">
                                    <thead className="table-primary text-center">
                                        <tr>
                                            <th scope="col">क्रं. सं.</th>
                                            <th scope="col">सदस्य का नाम</th>
                                            <th scope="col">पद</th>
                                            <th scope="col">अधिकारिक ई-मेल</th>
                                        </tr>
                                    </thead>
                                    <tbody className="text-center">
                                        <tr>
                                            <td>1</td>
                                            <td>श्री संजीव</td>
                                            <td>अधीक्षक, पंजीकरण शाखा</td>
                                            <td><a href="mailto:registration@mvsu.ac.in" className="text-decoration-none">registration@mvsu.ac.in</a></td>
                                        </tr>
                                        <tr>
                                            <td>2</td>
                                            <td>श्री प्रवीन कुमार</td>
                                            <td>सहायक, पंजीकरण</td>
                                            <td><a href="mailto:academic@mvsu.ac.in" className="text-decoration-none">academic@mvsu.ac.in</a></td>
                                        </tr>
                                        <tr>
                                            <td>3</td>
                                            <td>श्रीमती निर्मला देवी</td>
                                            <td>डी.ई.ओ., पंजीकरण शाखा</td>
                                            <td><a href="mailto:registration@mvsu.ac.in" className="text-decoration-none">registration@mvsu.ac.in</a></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        ),
    },
    {
        name: "क्रय/सामान्य शाखा",
        content: (
            <div className="card mb-4 shadow-sm">
                <div className="card-body">
                    <div className="card mb-4 shadow-sm">
                        <div className="card-body">
                            <h5 className="card-title text-center text-primary mb-3">कार्य एवं उद्देश्य</h5>
                            <p className="text-justify text-muted">
                                क्रय/सामान्य शाखा से संबंधित जानकारी यहां उपलब्ध होगी।
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        ),
    },
    {
        name: "परीक्षा शाखा",
        content: (
            <div className="card mb-4 shadow-sm">
                <div className="card-body">
                    <div className="card mb-4 shadow-sm">
                        <div className="card-body">
                            <h5 className="card-title text-center text-primary mb-3">परीक्षा शाखा के कार्य एवं उद्देश्य</h5>
                            <p className="text-justify">
                                परीक्षा शाखा विश्वविद्यालय का एक अभिन्न अंग है । इस शाखा का मुख्य उद्देश्य प्रश्न पत्र तैयार करवाना, परीक्षा आयोजित करना, परीक्षा परिणाम घोषित करना एवं परीक्षा पास करने वाले विद्यार्थियों को उनकी शास्त्री/आचार्य/विद्यावारिधि की उपाधियाँ दीक्षान्त समारोह के माध्यम से वितरित करना हैं ।
                            </p>
                            <p className="text-justify">
                                उक्त मुख्य उद्देश्य से सम्बन्धित कार्य जैसे आंतरिक मूल्यांकन अंक एवं बाह्यीय परीक्षा अंक का रिकॉर्ड रखना, APAAR ID का डाटा उपलब्ध करवाना तथा विश्वविद्यालय या उच्चतर शिक्षा विभाग या विश्वविद्यालय अनुदान आयोग या अन्य सरकारी विभाग द्वारा मांगी गई परीक्षा सम्बन्धी जानकारी उपलब्ध करवाना परीक्षा शाखा द्वारा सम्पन्न किये जाते हैं ।
                            </p>
                        </div>
                    </div>

                    <div className="card mb-4 shadow-sm">
                        <div className="card-body">
                            <h5 className="card-title text-center text-primary mb-4">परीक्षा शाखा में कार्यरत सदस्यों का विवरण</h5>
                            <div className="table-responsive">
                                <table className="table table-bordered table-hover align-middle">
                                    <thead className="table-primary text-center">
                                        <tr>
                                            <th scope="col">क्रम. स.</th>
                                            <th scope="col">सदस्यों का नाम</th>
                                            <th scope="col">पद</th>
                                            <th scope="col">आधिकारिक ई-मेल</th>
                                        </tr>
                                    </thead>
                                    <tbody className="text-center">
                                        <tr>
                                            <td>1</td>
                                            <td>प्रो. भाग सिंह बोदला</td>
                                            <td>परीक्षा नियंत्रक</td>
                                            <td><a href="mailto:coe@mvsu.ac.in" className="text-decoration-none">coe@mvsu.ac.in</a></td>
                                        </tr>
                                        <tr>
                                            <td>2</td>
                                            <td>श्री संजीव कुमार</td>
                                            <td>अधीक्षक</td>
                                            <td><a href="mailto:examination@mvsu.ac.in" className="text-decoration-none">examination@mvsu.ac.in</a></td>
                                        </tr>
                                        <tr>
                                            <td>3</td>
                                            <td>श्रीमती आरती शर्मा</td>
                                            <td>डी.ई.ओ.</td>
                                            <td><a href="mailto:examination@mvsu.ac.in" className="text-decoration-none">examination@mvsu.ac.in</a></td>
                                        </tr>
                                        <tr>
                                            <td>4</td>
                                            <td>श्रीमती सविता रानी</td>
                                            <td>डी.ई.ओ.</td>
                                            <td><a href="mailto:examination@mvsu.ac.in" className="text-decoration-none">examination@mvsu.ac.in</a></td>
                                        </tr>
                                        <tr>
                                            <td>5</td>
                                            <td>श्रीमती मीनू शर्मा</td>
                                            <td>डी.ई.ओ.</td>
                                            <td><a href="mailto:examination@mvsu.ac.in" className="text-decoration-none">examination@mvsu.ac.in</a></td>
                                        </tr>
                                        <tr>
                                            <td>6</td>
                                            <td>श्रीमती स्वाति सिंह</td>
                                            <td>डी.ई.ओ.</td>
                                            <td><a href="mailto:examination@mvsu.ac.in" className="text-decoration-none">examination@mvsu.ac.in</a></td>
                                        </tr>
                                        <tr>
                                            <td>7</td>
                                            <td>श्री दीपक</td>
                                            <td>डी.ई.ओ.</td>
                                            <td><a href="mailto:examination@mvsu.ac.in" className="text-decoration-none">examination@mvsu.ac.in</a></td>
                                        </tr>
                                        <tr>
                                            <td>8</td>
                                            <td>श्री अमरदीप शर्मा</td>
                                            <td>डी.ई.ओ.</td>
                                            <td><a href="mailto:examination@mvsu.ac.in" className="text-decoration-none">examination@mvsu.ac.in</a></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        ),
    },
    {
        name: "अभियांत्रिकी एवं निर्माण शाखा",
        content: (
            <div className="card mb-4 shadow-sm">
                <div className="card-body">
                    <div className="card mb-4 shadow-sm">
                        <div className="card-body">
                            <h5 className="card-title text-center text-primary mb-3">निर्माण शाखा का परिचय</h5>
                            <p className="text-justify">
                                विश्वविद्यालय निर्माण विभाग का गठन इमारतों के सभी सिविल कार्यों, बागवानी कार्यों की योजना, निर्माण, रखरखाव और मरम्मत के कार्यों की देखभाल के लिए किया गया है ।
                            </p>
                        </div>
                    </div>

                    <div className="card mb-4 shadow-sm">
                        <div className="card-body">
                            <h5 className="card-title text-center text-primary mb-3">कार्य एवं उद्देश्य</h5>
                            <p className="text-justify">
                                विश्वविद्यालय निर्माण विभाग का मुख्य उद्देश्य इमारतों के मूल कार्य, विशेष मरम्मत कार्य एवं इमारतों को उचित स्थिति में बनाए रखने हेतु अन्य सभी रखरखाव कार्य निष्पादित करना है ।
                            </p>
                        </div>
                    </div>

                    <div className="card mb-4 shadow-sm">
                        <div className="card-body">
                            <h5 className="card-title text-center text-primary mb-3">उपलब्धियां</h5>
                            <p className="text-justify">
                                विश्वविद्यालय निर्माणाधीन परिसर करनाल – कैथल मार्ग पर ग्राम मून्दड़ी में स्थित है । विश्वविद्यालय के पास लगभग 24 एकड़ भूमि आवंटित है । वर्तमान में विश्वविद्यालय के शैक्षणिक भवन, महिला एवं पुरूष छात्रावास तथा मुख्य द्वार का निर्माण कार्य प्रगति पर है ।
                            </p>
                            <div className="alert alert-info" role="alert">
                                <strong>नोट :</strong> वर्तमान में विश्वविद्यालय के पास दो अस्थाई परिसर (डॉ. भीम राव अम्बेड़कर राजकीय महाविद्यायालय, टीक परिसर) महिला एवं पुरूष छात्रावास तथा कुलपति कैम्प कार्यालय किराये की बिल्डिंग में संचालित किये जा रहे है ।
                            </div>
                        </div>
                    </div>

                    <div className="card mb-4 shadow-sm">
                        <div className="card-body">
                            <h5 className="card-title text-center text-primary mb-4">भवन निर्माण शाखा में कार्यरत अधिकारी एवं अन्य सदस्य</h5>
                            <div className="table-responsive">
                                <table className="table table-bordered table-hover align-middle">
                                    <thead className="table-primary text-center">
                                        <tr>
                                            <th scope="col">क्रं. स.</th>
                                            <th scope="col">अधिकारी/सदस्य</th>
                                            <th scope="col">पद</th>
                                        </tr>
                                    </thead>
                                    <tbody className="text-center">
                                        <tr>
                                            <td>1</td>
                                            <td>श्री सुभाष चन्द</td>
                                            <td>सम्पदा अधिकारी (अतिरिक्त कार्यभार)</td>
                                        </tr>
                                        <tr>
                                            <td>2</td>
                                            <td>श्री आनन्द वर्मा</td>
                                            <td>तकनीकि विशेषज्ञ (Visit Basis)</td>
                                        </tr>
                                        <tr>
                                            <td>3</td>
                                            <td>श्री सुनील शर्मा</td>
                                            <td>कनिष्ठ अभियंता (सिविल)</td>
                                        </tr>
                                        <tr>
                                            <td>4</td>
                                            <td>श्री विकास अत्री</td>
                                            <td>दफ्तरी</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        ),
    },
    {
        name: "स्थापना शाखा",
        content: (
            <div className="card mb-4 shadow-sm">
                <div className="card-body">
                    <div className="card mb-4 shadow-sm">
                        <div className="card-body">
                            <h5 className="card-title text-center text-primary mb-3">कार्य एवं उद्देश्य</h5>
                            <p className="text-justify text-muted">
                                स्थापना शाखा से संबंधित जानकारी यहां उपलब्ध होगी।
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        ),
    },
    {
        name: "NAD/Digi Locker शाखा",
        content: (
            <div className="card mb-4 shadow-sm">
                <div className="card-body">
                    <div className="card mb-4 shadow-sm">
                        <div className="card-body">
                            <h5 className="card-title text-center text-primary mb-3">Digi Locker परिचय</h5>
                            <p className="text-justify">
                                <strong>Digi Locker</strong> डिजिटल इंडिया कार्यक्रम के तहत भारत सरकार के इलैक्ट्रोनिक्स और सूचना प्राद्यौगिक मंत्रालय एवं मानव विकास मंत्रालय (MHRD) की महत्वपूर्ण पहल है जिसका उद्देश्य पेपरलेस सिस्टम अपनाकर ई-दस्तावेजों का आदान-प्रदान करके नागरिकों का 'डिजिटल सशक्तिकरण' करना है ।
                            </p>
                            <p className="text-justify">
                                <strong>NAD Digi locker</strong> का अर्थ है – राष्ट्रीय शैक्षणिक डिपॉजिटरी डिजिलॉकर, यह एक डिजिटल शिक्षा पोर्टल है जिस पर शैक्षणिक संस्थानों द्वारा जारी किये गये प्रमाण-पत्र, डिप्लोमा, डिग्री एवं मार्कशीट आदि अपलोड किये जाते है जिसका पोर्टल 24x7 ऑनलाईन डिजिटल संग्रह करता है ताकि छात्र आवश्यकतानुसार पोर्टल से APPAR ID माध्यम से अपने शैक्षणिक दस्तावेज डाउनलोड कर सकें ।
                            </p>
                        </div>
                    </div>

                    <div className="card mb-4 shadow-sm">
                        <div className="card-body">
                            <h5 className="card-title text-center text-primary mb-3">NAD/Digi Locker कार्य</h5>
                            <div className="text-justify">
                                <ol className="list-group list-group-flush">
                                    <li className="list-group-item border-0 px-0">विश्वविद्यालय के प्रत्येक सत्र के सभी विषय (आचार्य/M.A, शास्त्री/B.A एवं डिप्लोमा) में अध्ययनरत् विद्यार्थियों की APPAR ID बनाना ।</li>
                                    <li className="list-group-item border-0 px-0">परीक्षा शाखा से परीक्षा परिणाम व पञ्जीकरण शाखा से विद्यार्थियों का डाटा इकट्ठा करने के उपरान्त NAD/Digi locker पोर्टल पर सभी विषय (आचार्य/M.A, शास्त्री/B.A एवं डिप्लोमा) के विद्यार्थियों का डाटा तैयार कर अपलोड करना ।</li>
                                    <li className="list-group-item border-0 px-0">NAD/Digi locker से सम्बन्धित फाईले चलाना व डायरी-डिस्पेच इत्यादि कार्य करना ।</li>
                                </ol>
                            </div>
                        </div>
                    </div>

                    <div className="card mb-4 shadow-sm">
                        <div className="card-body">
                            <h5 className="card-title text-center text-primary mb-3">NAD/Digi Locker उद्देश्य</h5>
                            <div className="text-justify">
                                <ol className="list-group list-group-flush">
                                    <li className="list-group-item border-0 px-0">DHE & UGC के दिशा-निर्देशानुसार विश्वविद्यालय में अध्ययनरत् सभी छात्रों का परीक्षा परिणाम NAD/Digi locker पोर्टल पर उपलब्ध करवाने हेतु Academic Bank of Credit Account के लिए APPAR ID बनाना ताकि छात्र आवश्यकतानुसार Digi locker पोर्टल से APPAR ID द्वारा डिजिटल मार्कशीट डाउनलोड कर सकें ।</li>
                                    <li className="list-group-item border-0 px-0">UGC के अनुसार छात्रों के Credit Transfer से सम्बन्धित दस्तावेज तैयार करना ।</li>
                                </ol>
                            </div>
                        </div>
                    </div>

                    <div className="card mb-4 shadow-sm">
                        <div className="card-body">
                            <h5 className="card-title text-center text-primary mb-4">NAD/Digi Locker शाखा में कार्यरत सदस्यों का विवरण</h5>
                            <div className="table-responsive">
                                <table className="table table-bordered table-hover align-middle">
                                    <thead className="table-primary text-center">
                                        <tr>
                                            <th scope="col">क्रं. सं.</th>
                                            <th scope="col">अधिकारी/सदस्य का नाम</th>
                                            <th scope="col">पद</th>
                                            <th scope="col">आधिकारिक ई-मेल</th>
                                        </tr>
                                    </thead>
                                    <tbody className="text-center">
                                        <tr>
                                            <td>01.</td>
                                            <td>डॉ. चन्द्र कान्त</td>
                                            <td>Nodal Officer & System Admin (NAD/Digi locker Cell)</td>
                                            <td><a href="mailto:naddigilocker@mvsu.ac.in" className="text-decoration-none">naddigilocker@mvsu.ac.in</a></td>
                                        </tr>
                                        <tr>
                                            <td>02.</td>
                                            <td>राकेश कुमार</td>
                                            <td>DEO</td>
                                            <td>—</td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        ),
    },
    {
        name: "जन सम्पर्क अधिकारी (PRO)",
        content: (
            <div className="card mb-4 shadow-sm">
                <div className="card-body">
                    <div className="card mb-4 shadow-sm">
                        <div className="card-body">
                            <h5 className="card-title text-center text-primary mb-3">कार्य एवं उद्देश्य</h5>
                            <p className="text-justify">
                                महर्षि वाल्मीकि संस्कृत विश्वविद्यालय, कैथल के जनसंपर्क अधिकारी (PRO) का कार्य एवं उद्देश्य विश्वविद्यालय की गतिविधियों, कार्यक्रमों और शोध कार्यों को समाज, मीडिया और अन्य संस्थाओं तक प्रभावी ढंग से पहुँचाना है। उनका प्रमुख उद्देश्य विश्वविद्यालय की सकारात्मक छवि का निर्माण करना और संवाद के माध्यम से विश्वविद्यालय की गतिविधियों को व्यापक समुदाय तक पहुँचाना है।
                            </p>
                        </div>
                    </div>

                    <div className="card mb-4 shadow-sm">
                        <div className="card-body">
                            <h5 className="card-title text-center text-primary mb-3">प्रमुख कार्य</h5>
                            <div className="text-justify">
                                <ul className="list-group list-group-flush">
                                    <li className="list-group-item border-0 px-0"><strong>सूचना का प्रसार:</strong> विश्वविद्यालय द्वारा आयोजित कार्यक्रमों, शोध कार्यों, कार्यशालाओं और संगोष्ठियों की जानकारी मीडिया और समाज तक पहुँचाना।</li>
                                    <li className="list-group-item border-0 px-0"><strong>मीडिया से संवाद:</strong> प्रेस विज्ञप्तियाँ जारी करना, मीडिया से संवाद स्थापित करना और विश्वविद्यालय की गतिविधियों पर मीडिया कवरेज सुनिश्चित करना।</li>
                                    <li className="list-group-item border-0 px-0"><strong>सामाजिक मीडिया प्रबंधन:</strong> विश्वविद्यालय की वेबसाइट, सोशल मीडिया प्लेटफ़ॉर्म्स (जैसे फेसबुक, ट्विटर, इंस्टाग्राम) पर नियमित अद्यतन करना।</li>
                                    <li className="list-group-item border-0 px-0"><strong>कार्यक्रमों का आयोजन:</strong> विश्वविद्यालय द्वारा आयोजित कार्यक्रमों का प्रचार-प्रसार और मीडिया कवरेज सुनिश्चित करना।</li>
                                    <li className="list-group-item border-0 px-0"><strong>विद्यार्थियों और समाज के बीच संवाद:</strong> विद्यार्थियों की समस्याओं, सुझावों को प्रशासन तक पहुँचाना और विश्वविद्यालय की भूमिका को स्पष्ट करना।</li>
                                    <li className="list-group-item border-0 px-0"><strong>साक्षात्कार और प्रेस कॉन्फ्रेंस:</strong> अधिकारियों के साक्षात्कार आयोजित करना और विश्वविद्यालय की नीतियों पर प्रेस कॉन्फ्रेंस देना।</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="card mb-4 shadow-sm">
                        <div className="card-body">
                            <h5 className="card-title text-center text-primary mb-3">उद्देश्य</h5>
                            <div className="text-justify">
                                <ul className="list-group list-group-flush">
                                    <li className="list-group-item border-0 px-0">विश्वविद्यालय की सकारात्मक छवि का निर्माण।</li>
                                    <li className="list-group-item border-0 px-0">समाज में विश्वविद्यालय की गतिविधियों के प्रति जागरूकता बढ़ाना।</li>
                                    <li className="list-group-item border-0 px-0">विद्यार्थियों, शिक्षकों, प्रशासन और समाज के बीच संवाद स्थापित करना।</li>
                                    <li className="list-group-item border-0 px-0">अन्य शैक्षणिक संस्थाओं और मीडिया के साथ सहयोग को बढ़ावा देना।</li>
                                </ul>
                            </div>
                        </div>
                    </div>

                    <div className="card mb-4 shadow-sm">
                        <div className="card-body">
                            <h5 className="card-title text-center text-primary mb-4">कार्यालय में कार्यरत सदस्य</h5>
                            <div className="table-responsive">
                                <table className="table table-bordered table-hover align-middle">
                                    <thead className="table-primary text-center">
                                        <tr>
                                            <th scope="col">क्रं. सं.</th>
                                            <th scope="col">अधिकारी का नाम</th>
                                            <th scope="col">पद</th>
                                            <th scope="col">दूरभाष नं.</th>
                                            <th scope="col">ई-मेल</th>
                                        </tr>
                                    </thead>
                                    <tbody className="text-center">
                                        <tr>
                                            <td>1</td>
                                            <td>डॉ. गोविन्द वल्लभ</td>
                                            <td>प्रभारी (जन सम्पर्क अधिकारी)</td>
                                            <td>—</td>
                                            <td><a href="mailto:pro@mvsu.ac.in" className="text-decoration-none">pro@mvsu.ac.in</a></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>

                            <h6 className="mt-4 text-center text-secondary">गैर-शैक्षणिक सदस्य</h6>
                            <div className="table-responsive">
                                <table className="table table-bordered table-hover align-middle">
                                    <thead className="table-light text-center">
                                        <tr>
                                            <th scope="col">क्रं. सं.</th>
                                            <th scope="col">कर्मचारी का नाम</th>
                                            <th scope="col">पद</th>
                                            <th scope="col">दूरभाष नं.</th>
                                            <th scope="col">ई-मेल</th>
                                        </tr>
                                    </thead>
                                    <tbody className="text-center">
                                        <tr>
                                            <td>1</td>
                                            <td>श्री मुकेश कुमार</td>
                                            <td>लिपिक (HKRN)</td>
                                            <td><a href="tel:9592123777" className="text-decoration-none">9592-123-777</a></td>
                                            <td><a href="mailto:Mukeshkaushik680@gmail.com" className="text-decoration-none">Mukeshkaushik680@gmail.com</a></td>
                                        </tr>
                                    </tbody>
                                </table>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        ),
    },
];

export default function Department() {
    const [showSidebar, setShowSidebar] = useState(true);
    const [selectedDeptIndex, setSelectedDeptIndex] = useState(0);

    useEffect(() => {
        const handleResize = () => {
            setShowSidebar(window.innerWidth >= 768);
        };

        handleResize();
        window.addEventListener("resize", handleResize);

        return () => window.removeEventListener("resize", handleResize);
    }, []);

    return (
        <div className="d-flex vh-100 flex-column flex-md-row bg-light">
            <button
                className="btn d-md-none m-2 shadow-sm text-white"
                onClick={() => setShowSidebar(!showSidebar)}
                style={{
                    backgroundColor: "#77236b",
                    borderColor: "#77236b"
                }}
            >
                ☰ मेनू
            </button>

            <aside
                id="department-sidebar"
                className={`p-3 shadow-lg d-flex flex-column ${showSidebar ? "d-block" : "d-none"} d-md-flex col-md-3 bg-white`}
            >
                <h5 className="text-center fw-bold mb-3 text-dark">कार्यालय/शाखा</h5>
                <nav className="flex-grow-1 overflow-auto">
                    {departments.map((dept, index) => (
                        <a
                            href="#!"
                            key={index}
                            className={`d-block mb-1 p-2 rounded small text-decoration-none ${selectedDeptIndex === index
                                ? 'text-white fw-bold border border-light'
                                : 'bg-light text-dark'
                                }`}
                            style={{
                                cursor: "pointer",
                                backgroundColor: selectedDeptIndex === index ? "#77236b" : undefined
                            }}
                            onClick={(e) => {
                                e.preventDefault();
                                setSelectedDeptIndex(index);
                                if (window.innerWidth < 768) setShowSidebar(false);
                            }}
                        >
                            {dept.name}
                        </a>
                    ))}
                </nav>
            </aside>

            <main className="flex-grow-1 p-3 bg-white shadow col-md-9 overflow-auto d-flex flex-column">
                <h4 className="text-center fw-semibold mb-4" style={{ color: "#77236b" }}>
                    {departments[selectedDeptIndex]?.name || "कृपया एक अनुभाग चुनें"}
                </h4>
                <div className="flex-grow-1 overflow-auto">
                    {departments[selectedDeptIndex]?.content ||
                        <div className="card shadow-sm">
                            <div className="card-body text-center">
                                <p className="text-muted mt-5">कृपया बाईं ओर से एक कार्यालय या अनुभाग चुनें।</p>
                            </div>
                        </div>
                    }
                </div>
            </main>
        </div>
    );
}
